import { Component, OnInit } from '@angular/core';
import { DeviceService } from '../services/device.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CampaignService} from '../campaign/service/campaign.service';
import {first} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-device-view',
  templateUrl: './device-view.component.html',
  styleUrls: ['./device-view.component.css']
})
export class DeviceViewComponent implements OnInit {
  campaignId: any;
  campaignNumber: any;
  patientMRN: any;
  loading = false;
  devices: any;
  bgArray = ['bg-c-blue', 'bg-c-green', 'bg-c-yellow', 'bg-c-pink'];

  // tslint:disable-next-line:max-line-length
  constructor(private deviceService: DeviceService, private route: ActivatedRoute, private router: Router, private campaignService: CampaignService,  private toastr: ToastrService) {
    this.route.params.subscribe(routeParams => {this.campaignId = routeParams.campaignIdParam; });
    this.route.params.subscribe(routeParams => {this.campaignNumber = routeParams.campaignNumberParam; });
    this.route.params.subscribe(routeParams => {this.patientMRN = routeParams.patientMRNParam; });
    if (this.campaignNumber  === undefined) {
     this.loadCampaign();
    }
    this.loadDevices();
  }




  ngOnInit() {
  }

  loadDevices() {
    this.loading = true;
    this.deviceService.getCampaignDevices(this.campaignId).subscribe(devices => {
      this.devices = devices;
      this.loading = false;
    }, (error) => {
      this.loading = false;
      this.toastr.error('', 'Please try again, error in loading devices');
    });
  }

  loadCampaign() {
      this.campaignService.getCampaignsDetails(this.campaignId).subscribe(data => {
            console.log('campaign ::' + data.json());
            this.campaignNumber = data.json().campaignNumber;
            this.patientMRN = data.json().patientMRN;
          }, (error) => {
            //this.toastr.error('', 'Please try again');
          });
    }

  viewLiveData(campaignId, deviceId) {
    // this.router.navigate( [ '/elasticcare/live-data' ], { fragment: campaignId } );
    this.router.navigate([ '/elasticcare/live-data' ], { queryParams: { campaignId: campaignId, deviceId: deviceId} });
  }

  viewHistoryData(campaignId, deviceId) {
    this.router.navigate([ '/elasticcare/history-data' ], { queryParams: { campaignId: campaignId, deviceId: deviceId} });
  }
}
